import { globalState } from '@/components/Global/GlobalDataManagement';
import { getFetchOptionsWithAuth } from '@/dataExchange/utils/fetchOptions';
import { OnboardingSurveyPayload, OnboardingSurveyResponse } from '@/domain/survey';
import { HTTP_METHOD } from '@/utils/enums/dataExchange';

export const upsertOnboardingSurvey = async (params: OnboardingSurveyPayload): Promise<void> => {
    const response = await fetch(
        `${globalState.config.FQ_BASE_API_URL}/onboarding-survey`,
        getFetchOptionsWithAuth({ method: HTTP_METHOD.PUT, body: params })
    );

    if (!response.ok) {
        const parsedResponse = await response.json();
        throw parsedResponse;
    }
};

export const getOnboardingSurvey = async (): Promise<OnboardingSurveyResponse | null> => {
    const response = await fetch(
        `${globalState.config.FQ_BASE_API_URL}/onboarding-survey`,
        getFetchOptionsWithAuth({ contentType: null, method: HTTP_METHOD.GET })
    );

    if (response.status === 404) return null;

    if (!response.ok) {
        const parsedResponse = await response.json();
        throw parsedResponse;
    }

    const text = await response.text();
    return text ? JSON.parse(text) : null;
};
